import { render, staticRenderFns } from "./CreatePortfolioOperationModalHeader.vue?vue&type=template&id=26282905&scoped=true"
import script from "./CreatePortfolioOperationModalHeader.vue?vue&type=script&lang=js"
export * from "./CreatePortfolioOperationModalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26282905",
  null
  
)

export default component.exports